import React, { memo } from "react";
import VideoMC from "../../../components/VideoMC";

// RepliedVideoMessageMC - Organismo puro, toda la lógica de UI en el hook
export const RepliedVideoMessageMC = memo(({ conversation, message }) => (
  <div className="tw-relative tw-rounded-[9px] tw-overflow-hidden tw-border-[5px] tw-border-[#E4E4E4]">
    <VideoMC data={message} platform={conversation.platform} className="tw-w-[120px] tw-h-[80px]" />
  </div>
));

RepliedVideoMessageMC.displayName = "RepliedVideoMessageMC";

export default RepliedVideoMessageMC;
